<span id="notify"/>

<style>
#notify {
    background-color: var(--bg-secondary-color);
    
    margin: auto;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    text-align: center;

    position: fixed;
    bottom: 1.8rem;
    left: 50%;
    transform: translate(-50%, 0);
    

    opacity: 0%;
    transition: opacity 1.5s;

    /*box-shadow: 1px 1px 10px 10px rgba(0, 0, 0, 0.3);*/
    box-shadow: none;
}
</style>